import {
  clientConfigMap,
  organizationConfigMap,
} from '../config/clientUIConfig';

export const getClientConfig = (clientId, organizationName) => {
  const baseConfig =
    clientId && clientId in clientConfigMap
      ? clientConfigMap[clientId]
      : clientConfigMap.default;

  const orgConfig =
    organizationName && organizationName in organizationConfigMap
      ? organizationConfigMap[organizationName]
      : null;

  if (!orgConfig) {
    return baseConfig;
  }

  return {
    ...baseConfig,
    ...orgConfig,
    ui: {
      ...baseConfig.ui,
      ...orgConfig.ui,
    },
  };
};
